import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const STYLE_INSIGHTS_FRAGMENT = gql`
  fragment StyleInsights on StyleInsights {
    fixedText
    fixedHtml
    originalText
    violations {
      explanation
      text
    }
  }
`;

const MUTATION = gql`
  mutation ExtractAPStyleInsights($customerId: ID!, $text: String!, $html: String) {
    extractApStyleInsights(customerId: $customerId, text: $text, html: $html) {
      ...StyleInsights
    }
  }
  ${STYLE_INSIGHTS_FRAGMENT}
`;

export const extractAPStyleInsights = async ({ customerId, text, html }, options) => {
  const variables = {
    customerId,
    text,
    html,
  };

  // "text" is a required parameter currently, so in case "html" is provided, we need to set "text" to empty string
  if (html && !text) {
    variables.text = '';
  }

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
